import { render, staticRenderFns } from "./gift-note-editor.vue?vue&type=template&id=03009fa6&scoped=true&"
import script from "./gift-note-editor.vue?vue&type=script&lang=js&"
export * from "./gift-note-editor.vue?vue&type=script&lang=js&"
import style0 from "./gift-note-editor.vue?vue&type=style&index=0&id=03009fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03009fa6",
  null
  
)

export default component.exports